// UTILITY FUNCTIONS


// Utility function to save to localStorage
export const setItem = (key, value) => {
    try {
        // If the value is already a string, skip JSON.stringify. If it is an array or object, convert the value to a JSON string
        const serializedValue = typeof value === "string" ? value : JSON.stringify(value);
        localStorage.setItem(key, serializedValue); // Save the value to localStorage
    } catch (error) {
        console.error(`Error saving to localStorage: ${error}`); // Log an error if storage fails
    }
};



// Utility function to get from localStorage
export const getItem = (key) => {
    try {
        const serializedValue = localStorage.getItem(key); // Retrieve the serialized value
        return serializedValue ? JSON.parse(serializedValue) : null; //Parse and return the value in its original form or 'null' if value is not found
    } catch (error) {
        console.error(`Error reading from localStorage: ${error}`); // Log an error if retrieval fails
        return null; // return null on error 
    }
};



// Utility function to remove from localStorage
export const removeItem = (key) => {
    try {
        localStorage.removeItem(key); // Remove the key-value pair from localStorage
    } catch (error) {
        console.error(`Error removing from localStorage: ${error}`); // Log an error if removal fails
    }
};


// Utility function to clear localStorage
export const clearItems = () => {
    try {
        localStorage.clear(); // remove all items from localStorage
    } catch (error) {
        console.log(`Error clearing localStorage: ${error}`); // Log an error if clearing localStorage fails
    }
};